<template>
  <div class="main" id="list">
    <transition name="fade">
      <RankPost
        v-if="tab==1"
        ref="rankPost"
        :bscroll="bscroll"
      />
      <RankIntegral
        v-else
        ref="rankIntegral"
        :bscroll="bscroll"
      />
    </transition>
  </div>
</template>
<script>
import RankPost from '../RankPost'
import RankIntegral from '../RankIntegral'
import BScroll from '@better-scroll/core'
import NestedScroll from '@better-scroll/nested-scroll'
import Pullup from '@better-scroll/pull-up'

BScroll.use(NestedScroll)
BScroll.use(Pullup)
export default {
  name: 'DynamicItem',
  components: {
    RankPost,
    RankIntegral
  },
  props: [
    'tab'
  ],
  data () {
    return {
      bscroll: BScroll
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="less">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .rank-end{
    text-align: center;
    padding: 11px 0;
    font-size: 13px;
    color: #b0b4c4;
    background-color: #E7EAF3;
  }
  .rank-more{
    text-align: center;
    font-size: 14px;
    color: #0B1338;
  }
</style>
